import React from 'react';

// Row option cells show the action buttons as icons with the label in a tooltip. The flag rides a context so the
// pages passing rowOptions keep their call sites, and nested dialogs turn it back off - a React context reaches
// through MUI's portal, so a dialog opened from a row would otherwise render its Save button as a bare icon.
const RowOptionsContext = React.createContext(false);

export const RowOptionsIconOnly = ({ children }: { children: React.ReactNode }) => <RowOptionsContext.Provider value={true}>{children}</RowOptionsContext.Provider>;

export const NotRowOptions = ({ children }: { children: React.ReactNode }) => <RowOptionsContext.Provider value={false}>{children}</RowOptionsContext.Provider>;

export const useRowOptionsIconOnly = () => React.useContext(RowOptionsContext);
